import IFormInputs from './IFormInputs';
import * as React from 'react';
import {InputHTMLAttributes} from 'react';
import FormattedMessage from 'react-intl/dist/components/message';
import DateRenderer from "../formrenderers/DateRenderer";
import {Field} from 'redux-form';

export interface IDateProps extends IFormInputs, InputHTMLAttributes<HTMLInputElement> {
    isRequired?: boolean
}

export default (props: IDateProps) => {
    const { inputID, label = <FormattedMessage id="form.email" />,
        ...rest
    } = props;

    return (
        <Field name={inputID} label={label} type="text" component={DateRenderer} {...rest} />
    );
}